import { HTMLSelect } from "@blueprintjs/core";
import { useCallback } from "react";
import { useLocalStorage } from 'usehooks-ts';
import { MAP_CUSTOM_BACKGROUND_COLORS } from "../../../src/types/color";
import { LocalStorageKeys } from "../../../src/enum/localstorage";

export default function SettingsBackgroundColor(): JSX.Element {
    const [backgroundColor, setBackgroundColor] = useLocalStorage<number>(LocalStorageKeys.BackgroundColor, 0);

    const onChange = useCallback(
        (event: React.FormEvent<HTMLSelectElement>) => {
            setBackgroundColor(parseInt(event.currentTarget.value, 10))
        },
        [setBackgroundColor],
    )

    const colors = MAP_CUSTOM_BACKGROUND_COLORS;

    return (
        <div>
            <div><b>Background Color:</b></div>
            <div>
                <HTMLSelect
                    options={
                        colors.map(
                            (color) => ({
                                label: color.name,
                                value: color.id,
                            }),
                        )
                    }
                    onChange={onChange}
                    value={backgroundColor}
                />
            </div>
        </div>
    );
}
